import "./home.scss";
import { AppDispatch, RootState } from "store";
import { sessionSelector } from "reducers/session";
import { ConnectedProps, connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dashboard from "../../assets/DashboardIcon.svg";
import Polygons from "../../assets/PolygonsIcon.svg";
import Transactions from "../../assets/TransactionsIcon.svg";
import "./i18n";

const Home = ({ countryCode }: ConnectorProps) => {
  const { t } = useTranslation("Home");
  const testId = "home";

  const cards: { icon: string; name: string; url: string; id: string }[] = [
    {
      icon: Dashboard,
      name: t("dashboard"),
      url: `/${countryCode}/dashboard`,
      id: "dashboard",
    },
    {
      icon: Polygons,
      name: t("polygons"),
      url: `/${countryCode}/polygons`,
      id: "polygons",
    },
    {
      icon: Transactions,
      name: t("transactions"),
      url: `/${countryCode}/transaction`,
      id: "transactions",
    },
  ];

  return (
    <div className="home-container">
      <h2 data-testId={`${testId}-title`}>{t("title")}</h2>
      <div className="home-cards-container">
        {cards.map((card) => (
          <Link
            className="home-card"
            to={card.url}
            data-testId={`${testId}-card-${card.id}`}
          >
            <div className="icon-container">
              <img src={card.icon} alt={card.name} />
            </div>
            <h3 data-testId={`${testId}-card-${card.id}-title`}>{card.name}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  countryCode: sessionSelector(state).countryCode,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(Home);
